import currentUser from './currentUser'
import menuOptions from './menuOptions'
import {combineReducers} from 'redux'

const rootReducer = combineReducers({
    currentUser,
    menuOptions
})

export default rootReducer